import React from 'react';
import { useDocuments } from '../../hooks/useDocuments';

/**
 * List layout used by every document page except Annual Report
 * (matches the original .policies-text + <hr> markup exactly).
 */
export function DocumentList({ category }) {
  const { documents, status } = useDocuments(category);

  if (status === 'loading') {
    return <p className="policies-text">Loading documents...</p>;
  }
  if (status === 'error') {
    return <p className="policies-text">Unable to load documents. Please try again.</p>;
  }
  if (documents.length === 0) {
    return <p className="policies-text">No documents available.</p>;
  }

  return (
    <>
      {documents.map((doc) => (
        <React.Fragment key={doc.id}>
          <p className="policies-text">
            <i className="fa-regular fa-file-pdf" style={{ color: 'red', fontSize: '20px' }}></i>{' '}
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', fontSize: '16px' }}
            >
              {doc.title}
            </a>
          </p>
          <hr />
        </React.Fragment>
      ))}
    </>
  );
}

/**
 * Grid layout used by Annual Report
 * (matches the original .reports-container/.report-item/.report-link markup).
 */
export function DocumentGrid({ category }) {
  const { documents, status } = useDocuments(category);

  if (status === 'loading') {
    return <p className="text-center">Loading documents...</p>;
  }
  if (status === 'error') {
    return <p className="text-center">Unable to load documents. Please try again.</p>;
  }
  if (documents.length === 0) {
    return <p className="text-center">No documents available.</p>;
  }

  return (
    <div className="reports-container">
      {documents.map((doc) => (
        <a href={doc.url} className="report-link" key={doc.id} target="_blank" rel="noopener noreferrer">
          <div className="report-item">
            <i className="fa-regular fa-file-pdf pdf-icon" style={{ color: 'red', fontSize: '20px' }}></i>
            <span>{doc.title}</span>
          </div>
        </a>
      ))}
    </div>
  );
}
